import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import Grid from '@material-ui/core/Grid';
import LandingCard from '../../../components/Card/LandingCard';
import { LandingPageDetails } from '../../../interfaces/details';
import ApproviedIcon from '../../../assets/icons/Approved';
import SecurityIcon from '../../../assets/icons/Security';
import { EXTERNAL_LINKS } from '../../../app-config';
import usePageStyles from '../styles';
import { DSTheme } from '../../../styles/themes/types';

const solutions: LandingPageDetails[] = [
  {
    Icon: ApproviedIcon,
    title: 'Personal Data Account Authentication Service',
    details: [
      'Sensitive data access and handling',
      'Secure, verifiable, dynamically sourced',
      'Legal, transparent data transactions',
    ],
    link: EXTERNAL_LINKS.dataswiftAuth,
  },
  {
    Icon: SecurityIcon,
    title: 'Single Sign On',
    details: [
      'Seamlessly verify user identity and supplementary information',
      'Personalise your website with data from your own user',
      'Backup user sessions',
    ],
    link: EXTERNAL_LINKS.dataswiftSSO,
  },
];
const useStyles = makeStyles((theme: DSTheme) => ({
  dataswiftSolutions: {
    backgroundColor: theme.palette.background.navigation,
  },
}));

const DataswiftSolutions: React.FC = () => {
  const pageClasses = usePageStyles();
  const classes = useStyles();

  return (
    <Grid container className={`${pageClasses.section} ${classes.dataswiftSolutions}`}>
      <Grid container justifyContent="center">
        <Grid item>
          <Typography className={pageClasses.text} variant="h1">
            Dataswift Solutions
          </Typography>
        </Grid>
      </Grid>
      <Grid container justifyContent="center" direction="row" spacing={3}>
        {solutions.map((solution) => (
          <Grid item key={solution.title}>
            <LandingCard {...solution} />
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};

export default DataswiftSolutions;
